import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductionDevicePageComponent } from './production-device-page.component';

const routes: Routes = [
  {
    path: 'production-device-page',
    data: { name: 'Production Device', isTab: false },
    component: ProductionDevicePageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductionDevicePageRoutingModule1 {}
